<script>
import {defineComponent} from 'vue'
import {ElMessage, ElMessageBox, ElNotification} from "element-plus";
import moment from "moment";
import EconomicIndicatorForm from "@/views/economic/indicators/EconomicIndicatorForm.vue";

export default defineComponent({
  name: "EconomicIndicatorList",
  components: {EconomicIndicatorForm},
  computed: {
    moment() {
      return moment
    }
  },
  data() {
    return {
      loading: false,
      economic_classification_id: null,
      year: null,
      quarter: null,
      quarters: [{value: 1}, {value: 2}, {value: 3}, {value: 4}],
      tableData: [],
      page: 1,
      totalCount: 0,
      limit: 10,
    }
  },
  methods: {
    indexMethod(index) {
      return index + (this.page - 1) * this.limit + 1
    },
    onFilterChange() {
      this.page = 1;
      this.getExpenseIndicators();
    },
    disabledYear(date) {
      return date.getFullYear() < 2018;
    },
    handleCurrentChange() {
      this.getExpenseIndicators();
    },
    handleSizeChange() {
      this.page = 1;
      this.getExpenseIndicators();
    },
    onClickDelete(id) {
      ElMessageBox.confirm(
          'Ma\'lumoitni o\'chirasizmi?',
          'Diqqat!',
          {
            confirmButtonText: 'Ha',
            cancelButtonText: 'Bekor qilish',
            type: 'warning',
          }
      )
          .then(() => {
            this.loading = true
            this.$http.delete(`/api/v1/economic-classification-indicators/${id}`).then(() => {
              ElMessage({
                type: 'success',
                message: 'Muvaffaqqiyatli o\'chirildi',
              })
              this.getExpenseIndicators();
            }).catch(() => {
              ElNotification({
                type: 'error',
                title: 'Xatolik',
                message: 'Iltimos, qayta urinib ko\'ring',
              })
            }).finally(() => {
              this.loading = false
            })
          })
          .catch(() => {
            ElMessage({
              type: 'info',
              message: 'O\'chirish bekor qilindi',
            })
          })
    },

    getExpenseIndicators() {
      this.loading = true;
      this.$http.get(`api/v1/economic-classification-indicators`, {
        params: {
          economic_classification_id: this.economic_classification_id || undefined,
          year: this.year ? Number(this.year) : undefined,
          quarter: this.quarter || undefined,
          limit: this.limit,
          offset: this.limit * (this.page - 1)
        }
      }).then(({data}) => {
        this.tableData = data.data;
        this.totalCount = data.count;
      }).catch(({response}) => {
        ElNotification.error({message: response.data.message || "Ma'lumot yuklashda xatolik sodir bo'ldi. Iltimos, qayta urinib ko'ring."})
      }).finally(() => {
        this.loading = false
      })
    },
  },
  mounted() {
    if (this.$route.query.parent) {
      this.economic_classification_id = parseInt(this.$route.query.parent);
    }
    this.getExpenseIndicators();
  }
})
</script>

<template>
  <div v-loading.fullscreen="loading">
    <div class="header">
      <div class="filters">
        <el-date-picker
            v-model="year"
            type="year"
            format="YYYY"
            value-format="YYYY"
            placeholder="Yil bo'yicha filter"
            clearable
            :disabled-date="disabledYear"
            style="width: 180px"
            @change="onFilterChange"
        />
        <el-select
            v-model="quarter"
            placeholder="Chorak bo'yicha filter"
            clearable
            style="width: 180px"
            @change="onFilterChange"
        >
          <el-option v-for="item in quarters" :key="item.value" :value="item.value" :label="item.value"/>
        </el-select>
      </div>
      <economic-indicator-form :economic_classification_id="economic_classification_id"
                               @getData="getExpenseIndicators"/>
    </div>
    <el-table :data="tableData" class="table" border height="calc(100vh - 230px)">
      <el-table-column type="expand">
        <template #default="props">
          <div class="child-table-wrap">
            <el-table
                v-if="props.row.child_economic_classification_indicators && props.row.child_economic_classification_indicators.length"
                :data="props.row.child_economic_classification_indicators"
                border
                size="small"
            >
              <el-table-column type="expand">
                <template #default="childProps">
                  <div class="child-table-wrap">
                    <el-table
                        v-if="childProps.row.child_economic_classification_indicators && childProps.row.child_economic_classification_indicators.length"
                        :data="childProps.row.child_economic_classification_indicators"
                        border
                        size="small"
                    >
                      <el-table-column type="index" label="T/R" width="80" align="center"/>
                      <el-table-column label="Ichki klassifikator" prop="economic_classification" min-width="180"/>
                      <el-table-column label="Yil" prop="year" width="80"/>
                      <el-table-column label="Chorak" prop="quarter" width="90"/>
                      <el-table-column label="Miqdor" prop="amount" min-width="140"/>
                      <el-table-column label="" align="center" width="200">
                        <template #default="grandScope">
                          <economic-indicator-form
                              :id="grandScope.row.id"
                              :economic_classification_id="grandScope.row.economic_classification_id"
                              @getData="getExpenseIndicators"/>
                          <el-button style="margin-left: 8px" type="danger" size="small"
                                     @click="onClickDelete(grandScope.row.id)">
                            O'chirish
                          </el-button>
                        </template>
                      </el-table-column>
                    </el-table>
                    <el-empty v-else description="Ichki ko'rsatgichlar yo'q" :image-size="60"/>
                  </div>
                </template>
              </el-table-column>
              <el-table-column type="index" label="T/R" width="80" align="center"/>
              <el-table-column label="Bola klassifikatori" prop="economic_classification" min-width="180"/>
              <el-table-column label="Yil" prop="year" width="80"/>
              <el-table-column label="Chorak" prop="quarter" width="90"/>
              <el-table-column label="Miqdor" prop="amount" min-width="140"/>
              <el-table-column label="" align="center" width="200">
                <template #default="childScope">
                  <economic-indicator-form
                      :id="childScope.row.id"
                      :economic_classification_id="childScope.row.economic_classification_id"
                      @getData="getExpenseIndicators"/>
                  <el-button style="margin-left: 8px" type="danger" size="small"
                             @click="onClickDelete(childScope.row.id)">
                    O'chirish
                  </el-button>
                </template>
              </el-table-column>
            </el-table>
            <el-empty v-else description="Bola ko'rsatgichlar yo'q" :image-size="60"/>
          </div>
        </template>
      </el-table-column>
      <el-table-column type="index" label="T/R" width="80" :index="indexMethod" align="center"/>
      <el-table-column label="Klassifikator" prop="economic_classification" min-width="180"/>
      <el-table-column label="Yil" prop="year" width="80"/>
      <el-table-column label="Chorak" prop="quarter" width="90"/>
      <el-table-column label="Miqdor" prop="amount" min-width="140"/>
      <el-table-column label="" align="center" width="200">
        <template #default="scope">
          <economic-indicator-form :id="scope.row.id" :economic_classification_id="scope.row.economic_classification_id"
                                   @getData="getExpenseIndicators"/>
          <el-button style="margin-left: 8px" type="danger" size="small" @click="onClickDelete(scope.row.id)">
            O'chirish
          </el-button>
        </template>
      </el-table-column>
    </el-table>
    <div class="pagination">
      <div>Umumiy soni: {{ totalCount }}</div>
      <el-pagination
          background
          layout="sizes, prev, pager, next"
          :total="totalCount"
          v-model:page-size="limit"
          v-model:current-page="page"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
      />
    </div>
  </div>
</template>

<style scoped>
.header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 10px;
  gap: 10px;
}

.filters {
  display: flex;
  align-items: center;
  gap: 10px;
}

.pagination {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 10px;
  margin-top: 10px;
}

.child-table-wrap {
  padding: 10px 16px;
}
</style>
